import Vue from 'vue';
import { get, sync } from 'vuex-pathify';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'companies-callable',
  computed: {
    changed: sync('auth/passwordChanged'),
    getLoading: get('accounts/getLoading'),
    getAuthError: get('auth/getAuthError'),
    getAppUserInfo: get('auth/getUserInfo'),
    getCurrentUser: get('accounts/getCurrentUser')
  },
  methods: {
    ...mapActions({
      passwordConfirm: 'auth/passwordConfirm',
      passwordResetConfirm: 'auth/passwordResetConfirm',
      forgotPassword: 'auth/forgotPassword',
      verifyEmail: 'auth/verifyEmail',
      requestEmail: 'auth/requestEmail',
      logout: 'auth/logout',
      login: 'auth/login',
      clearError: 'auth/clearError'
    })
  }
});
